/**
 * CenterSlice State Definition
 * 
 * Defines the state interface and initial state for the center slice.
 */

/**
 * State interface for the center slice.
 */
export interface CenterSliceState {
  /** The currently selected center code */
  selectedCenter: string;
}

/**
 * Initial state for the center slice.
 */
export const initialState: CenterSliceState = {
  selectedCenter: '',
};
